import React from 'react';

import { Number, Text } from '../../../Components/Form';
import DefaultImage from '../Assets/Images/default.png';

const Signature = ({
  context,
  signatureLoading,
  onChange,
  signatureRef,
  onSignatureFileSelect,
}) => {
  return (
    <div className='row p-2'>
      <div className='col-12'>
        <div className='d-flex flex-row align-items-center my-2 border-bottom pb-2'>
          <i className='fas fa-signature text-dark f-20'></i>
          <h1 className='text-dark f-15 font-weight-bold mx-2 mt-2'>امضاء</h1>
        </div>
      </div>
      <div className='col-12 col-md-6'>
        <div className='form-group mb-5'>
          <div className='d-flex flex-column justify-content-center align-items-center mt-1 mx-2'>
            <label>امضاء</label>
            <input
              type='file'
              className='d-none'
              ref={signatureRef}
              id={`background-signature-image`}
              onChange={() => onSignatureFileSelect()}
            />
            {signatureLoading ? (
              <div
                className='bg-white img-thumbnail c-pointer d-flex flex-column justify-content-center align-items-center'
                style={{ width: '100px', height: '100px' }}
              >
                <div
                  className='spinner-border text-dark spinner-border-sm mb-1'
                  role='status'
                >
                  <span className='sr-only'></span>
                </div>
              </div>
            ) : (
              <img
                onClick={() => {
                  let input = document.getElementById(
                    `background-signature-image`,
                  );
                  input.click();
                }}
                className='bg-white img-thumbnail c-pointer'
                style={{ width: '100px', height: '100px' }}
                src={
                  context.signature?.background_image !== null &&
                  context.signature?.background_image.length > 0
                    ? context.signature?.background_image
                    : DefaultImage
                }
                alt='im'
              />
            )}
          </div>
        </div>
      </div>
      <div className='col-12 col-md-3'>
        <Text
          title='عرض (cm)'
          name='width'
          formikOnChange={false}
          onChange={(value) => onChange('width', value)}
          value={context?.signature?.width}
        />
      </div>
      <div className='col-12 col-md-3'>
        <Text
          title='ارتفاع (cm)'
          name='height'
          formikOnChange={false}
          onChange={(value) => onChange('height', value)}
          value={context?.signature?.height}
        />
      </div>
      <div className='col-12 col-md-3'>
        <Number
          title='فاصله از بالا'
          name='top'
          defaultValue={context?.signature?.top}
          formikOnChange={false}
          onChange={(value) => onChange('top', value)}
          value={context?.signature?.top}
        />
      </div>
      <div className='col-12 col-md-3'>
        <Number
          title='فاصله از راست'
          name='right'
          defaultValue={context?.signature?.right}
          formikOnChange={false}
          onChange={(value) => onChange('right', value)}
          value={context?.signature?.right}
        />
      </div>
      <div className='col-12 col-md-3'>
        <Number
          title='فاصله از چپ'
          name='left'
          formikOnChange={false}
          defaultValue={context?.signature?.left}
          onChange={(value) => onChange('left', value)}
          value={context?.signature?.left}
        />
      </div>
      <div className='col-12 col-md-3'>
        <Number
          title='فاصله از پایین'
          name='bottom'
          formikOnChange={false}
          defaultValue={context?.signature?.bottom}
          onChange={(value) => onChange('bottom', value)}
          value={context?.signature?.bottom}
        />
      </div>
    </div>
  );
};
export default Signature;
